import script from "./SelectDateTime.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectDateTime.vue?vue&type=script&setup=true&lang=js"

import "./SelectDateTime.vue?vue&type=style&index=0&id=98cb40da&scoped=true&lang=css"

import exportComponent from "/var/www/html/frezka-saas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98cb40da"]])

export default __exports__